<template>
  <div class="onr-referral">
    <div class="onr-referral__container">
      <h4 class="referral-code__label">Referral code</h4>
      <input
          class="onr-referral__text-field"
          ref="referralCode"
          v-model="code"
          field-id="referral-code"
          input-type="single-line"
          placeholder="Enter referral code"
      />
      <button class="onr-referral__button" @click="onCodeSubmit()">Submit</button>
    </div>
  </div>
</template>

<script>
import { referral } from "@/api";
import { isNjonnuriBypassCode, NJONNURI_BYPASS_CODE, NJONNURI_BYPASS_ROLE } from "@/utils/referralBypass";

export default {
  name: 'ReferralCodePage',
  components: {},
  props: {},
  data() {
    return {
      code: '',
    }
  },
  computed: {
  },
  mounted() {

  },
  methods: {
    onCodeSubmit() {
      const code = this.code.trim();

      if (!code) {
        alert('Invalid referral code');
        return;
      }

      if (isNjonnuriBypassCode(code)) {
        // Recognized shortcut, not a row in the `referrals` table — skip
        // the DB round trip entirely, same result as the ?code=njonnuri
        // URL-based bypass in loginOverlay.vue.
        localStorage.setItem('code', NJONNURI_BYPASS_CODE);
        localStorage.setItem('role', NJONNURI_BYPASS_ROLE);
        this.verified();
        return;
      }

      referral(code)
          .then(res => {
            if (res.code !== undefined && res.code.toUpperCase() === code.toUpperCase()) {
              localStorage.setItem('code', code);
              localStorage.setItem('role', res.role);
              this.verified();
              return;
            }

            throw new Error('Referral code response did not match submitted code');
          })
          .catch(err => {
            console.log(err);
            alert('Invalid referral code');
          });
    },
    verified() {
      this.$emit('verify');
    },
  }
}
</script>

<style lang="scss">
@use '../../utils/_tokens.scss' as *;

.onr-referral {
  display: flex;

  &__container {
    display: flex;
    flex-direction: column;
    margin-top: 10%;

    .referral-code {
      &__label {
        color: var(--ink-2);
        font-size: 13px;
        font-weight: 600;
        letter-spacing: .12em;
        margin-bottom: 0.5rem;
        text-align: left;
        text-transform: uppercase;
      }
    }
  }

  &__text-field {
    border: 1px solid $grey-4;
    border-radius: 12px;
    font-family: var(--display);
    font-size: 16px;
    height: 44px;
    padding-left: 14px;

    &:focus {
      border-color: $blue-2;
      box-shadow: 0 0 0 3px rgba(59, 70, 184, .18);
      outline: none;
    }

    margin-bottom: 2rem;
    width: 250px;

  }

  &__button {
    background-color: $blue-1;
    border: 2px solid transparent;
    border-radius: 999px;
    color: white;
    cursor: pointer;
    font-family: var(--display);
    font-size: 16px;
    font-weight: 600;
    padding: 12px 22px;
    transition: transform .15s ease;

    &:hover {
      transform: translateY(-1px);
    }
  }
}
</style>
